import React, { useState } from "react";
import { ReactComponent as DashboardLogo } from "./assets/images/migration.svg";
import ForecastImport from "./components/ForecastImport";
import SalesImport from "./components/SalesImport";
import ContentHeader from "../../components/ContentHeader";

import "./assets/css/style.css";

const System: React.FC = () => {
    const [content, setContent] = useState<string>("forecast");

    const changeContent = (content: string) => {
        setContent(content);
    };

    return (
        <div className="wrapperApp">
            <ContentHeader
                title="System"
                Icon={DashboardLogo}
                breadcrumb={["System"]}
            />
            <div id="content">
                <div className="tabs">
                    <div className="tabs__buttons">
                        <button
                            className={`tabs__tablinks ${
                                content === "forecast" ? "tabs__tablinks--active" : ""
                                }`}
                            onClick={() => {
                                changeContent("forecast");
                            }}
                        >
                            Forecast
            </button>
                        <button
                            className={`tabs__tablinks ${
                                content === "sales" ? "tabs__tablinks--active" : ""
                                }`}
                            onClick={() => {
                                changeContent("sales");
                            }}
                        >
                            Sales
            </button>
                    </div>
                    <div className="tabs__tabcontent">
                        {content === "forecast" ? (
                            <ForecastImport />
                        ) : (
                            <SalesImport />    
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default System;
